export default "__VITE_ASSET__BreGOfS2__"